import { Injectable } from "@angular/core";
import { RemoteConferenceStream } from "youm-lib/conference";
import { BaseList } from "./base-list";

@Injectable()
export class RemoteConferenceStreamsListService extends BaseList<RemoteConferenceStream> {
  get streams() {
    return super.items;
  }

  get streams$() {
    return super.items$;
  }

  compare(
    item1: RemoteConferenceStream,
    item2: RemoteConferenceStream
  ): number {
    return item1.streamId.localeCompare(item2.streamId);
  }
}
